import type { CentinelaTestCallInput } from "../../../features/centinela/types";
import type { CallEventType } from "../types";

export const CENTINELA_CALL_TYPE_IDS = {
  route_deviation: "desvio_ruta",
  unauthorized_stop: "parada_no_autorizada",
  danger_zone: "zona_peligro",
  speeding: "exceso_velocidad",
  routine: "rutina",
  suspicious_stop: "parada_sospechosa",
  gps_loss: "sin_gps",
  jamming: "jamming",
  delivery_confirmation: "confirmacion_entrega",
} as const satisfies Record<CallEventType, string>;

export const TEST_CALL_DEFAULTS = {
  unidad: "U-01",
  perfil: "operador",
} as const;

export function buildTestCallInput({
  type,
  phone,
  name,
  unit,
  profile,
}: {
  type: CallEventType;
  phone: string;
  name: string;
  unit?: string;
  profile?: string;
}): CentinelaTestCallInput {
  return {
    telefono: phone,
    tipo: CENTINELA_CALL_TYPE_IDS[type],
    nombre: name,
    unidad: unit?.trim() || TEST_CALL_DEFAULTS.unidad,
    perfil: profile?.trim() || TEST_CALL_DEFAULTS.perfil,
  };
}

export function toE164(countryCode: string, phone: string): string | null {
  const digits = phone.replace(/\D/g, "");
  if (digits.length < 8 || digits.length > 15) return null;
  return `${countryCode}${digits}`;
}

export function fromE164(
  value: string,
  codes: readonly string[],
): { code: string; digits: string } | null {
  const trimmed = value.trim();
  if (!trimmed.startsWith("+")) return null;

  const code = codes
    .filter((candidate) => trimmed.startsWith(candidate))
    .sort((a, b) => b.length - a.length)[0];
  if (!code) return null;

  const digits = trimmed.slice(code.length).replace(/\D/g, "");
  return digits ? { code, digits } : null;
}

export const testCallErrorMessage = (error: unknown) =>
  (error as { response?: { data?: { meta?: { message?: string } } } })?.response?.data?.meta
    ?.message;
